import { Component, OnInit } from '@angular/core';
import '@angular/localize/init';

@Component({
  selector: 'bn-account-details-widget-extended',
  templateUrl: 'account-details-widget-extended.component.html',
  styles: [],
})
export class AccountDetailsWidgetExtendedComponent implements OnInit {
  readonly productNumberCreditCardFormat = { length: 16, maskRange: [0, 0], segments: 4 };
  productNumberFormat = { length: 16, maskRange: [0, 0], segments: 4 };
  loadingText = $localize`:@@product.details.loadingAccount:Loading account`;

  constructor() {}

  ngOnInit(): void {}

  getProductTitle(item: any) {
    let title = item.productTypeName;
    if (item.additions?.cardTypeCode === 'A') {
      title += ' (' + $localize`:@@product-summary.credit-cards.additional-text:Additional` + ')';
    }
    return title;
  }
}
